var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-secondary-table-layout',{attrs:{"icon":"mdi-cogs","card-title":_vm.$t('rawProduct.processedItems')},scopedSlots:_vm._u([{key:"button",fn:function(){return [_c('v-spacer'),(_vm.itemResource)?_c('base-new-outlined-button',{attrs:{"to":{
        name: 'item-raw-product-new',
        params: { itemResourceId: _vm.itemResourceId }
      }}},[_vm._v(_vm._s(_vm.$tc('item.name', 1)))]):_vm._e(),_c('ItemResourceConfirmationButton')]},proxy:true}])},[_c('ItemRawProductIndexTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }